import React, {Component, Fragment} from 'react';
import Select from 'react-select';
import { wizardFooterButtons } from "../../utils/SelectStyles";
import {get} from 'lodash';
import isEmpty from "../../utils/helpers";

class StateSelect extends Component {

    handleBlur = () => {
        if (typeof this.props.onBlur === 'function') {
            this.props.onBlur(this.props.fieldName, true);
        }
    };

    render() {
        const {options, value, placeholder, title, errors, touched, fieldName, isDisabled, isLoading, onChange, submitCount} = this.props;

        const getValue = () => {
            if (!isEmpty(options)) {
                return options.find(option => option.value === value) || "";
            } else {
                return "";
            }
        };

        const onChangeInternal = (option) => {
            if(option !== null){
                if (!isEmpty(onChange)) {
                    onChange(fieldName, option.value);
                }
            } else {
                if (!isEmpty(onChange)) {
                    onChange(fieldName, '');
                }
            }
        }

        return (
            <Fragment>
                {title && (
                    <label htmlFor={fieldName}>{title}</label>
                )}

                <Select
                    inputId={fieldName}
                    name={fieldName}
                    options={options}
                    isMulti={false}
                    onChange={onChangeInternal}
                    onBlur={this.handleBlur}
                    value={getValue()}
                    placeholder={placeholder}
                    styles={wizardFooterButtons}
                    isDisabled={isDisabled}
                    isLoading={isLoading}
                    isClearable={false}
                    className={get(errors, `${fieldName}`) && (get(touched, `${fieldName}`) || submitCount > 0) && "is-invalid" || ""}
                />

                {get(errors, `${fieldName}`) && (get(touched, `${fieldName}`) || submitCount > 0) && (
                    <div className="invalid-feedback">{get(errors, `${fieldName}`)}</div>
                )}

            </Fragment>
        );
    }
}

export default StateSelect;
